import { render } from "./Footer-Home.vue?vue&type=template&id=281bb813&scoped=true"
const script = {}

import "./Footer-Home.vue?vue&type=style&index=0&id=281bb813&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281bb813"]])

export default __exports__